// Obnova dat z serveru — jedno místo pro „tvrdý" i „lehký" refresh.
//
// Řidiči dřív neměli jak si vynutit čerstvá data: `route/today` má staleTime
// 5 min, refetchOnWindowFocus je vypnutý (Ionic drží obrazovky v DOMu) a Dexie
// drží offline snapshot. Když dispečer za pochodu přehodil zastávku nebo dal
// storno, řidič to viděl až po restartu aplikace.

import { queryClient } from "./queryClient";
import { clearOfflineCaches } from "./db";
import { useShiftStore } from "../store/shiftStore";
import { useStopProgressStore } from "../store/stopProgressStore";
import { useSyncStore } from "../store/syncStore";

/**
 * Tvrdý refresh (tlačítko v liště / pull-to-refresh).
 *
 * Zahodí offline snapshot i celou query cache, znovu načte směnu a přehraje
 * progress z event logu na backendu. Zároveň se pokusí odeslat frontu, aby
 * řidič po kliknutí viděl skutečný stav, ne rozjetý lokální.
 */
export async function hardRefresh(): Promise<void> {
  const { online } = useSyncStore.getState();

  // Offline nemá co obnovovat — Dexie cache je jediné, co řidič má. Smazat ji
  // by znamenalo prázdnou trasu uprostřed dne.
  if (!online) {
    await useSyncStore.getState().refreshCount();
    return;
  }

  try { await useSyncStore.getState().syncNow(); } catch { /* ignore */ }

  try { await clearOfflineCaches(); } catch { /* ignore */ }
  await queryClient.invalidateQueries();

  try { await useShiftStore.getState().refresh(); } catch { /* ignore */ }
  const shift = useShiftStore.getState().shift;
  if (shift?.id && !shift.end_ts) {
    try { await useStopProgressStore.getState().hydrateFromBackend(shift.id); } catch { /* ignore */ }
  }
  try { await useSyncStore.getState().refreshCount(); } catch { /* ignore */ }
}

/**
 * Lehká obnova po akci na zastávce (dokončení / marná jízda / storno).
 *
 * Jen označí trasu za neaktuální, ať se natáhne případný zásah dispečera —
 * bez mazání offline cache, aby řidič nezůstal na prázdné obrazovce, když
 * refetch selže. Offline se přeskočí (query by jen zbytečně selhala).
 */
export function refreshRouteAfterStop(): void {
  if (!useSyncStore.getState().online) return;
  void queryClient.invalidateQueries({ queryKey: ["mobile", "route", "today"] });
  void queryClient.invalidateQueries({ queryKey: ["mobile", "route", "status"] });
}
